import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Restores top-of-page on navigation and honours `#fragment` links by
 * deferring to the element once the new route has painted.
 */
export function ScrollManager() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) {
      const id = hash.slice(1);
      const attempt = () => {
        const el = document.getElementById(id);
        if (!el) return false;
        const top = el.getBoundingClientRect().top + window.scrollY - 84;
        window.scrollTo({ top, behavior: "smooth" });
        return true;
      };
      if (!attempt()) {
        const timer = setTimeout(attempt, 120);
        return () => clearTimeout(timer);
      }
      return undefined;
    }
    window.scrollTo({ top: 0, left: 0, behavior: "instant" in window ? "instant" : "auto" });
    return undefined;
  }, [pathname, hash]);

  return null;
}

export default ScrollManager;
